import React from 'react';

import Seo from 'src/uglib_components/seo'
import SidebarLayout from 'src/uglib_components/sidebarLayout'
import WebForm from 'src/uglib_components/webform';
import Sidebar from 'src/uglib_components/sidebar';
import SidebarMenu from 'src/uglib_components/sidebarMenu';

import { email } from 'src/uglib_utils/forms';

const CourseReserveQuestion = ({ location }) => {
    const breadcrumbs = [
		{ 
			url: "",
			title: "Find",
		},
        { 
			url: "/find/course-reserves-ares",
			title: "Course Reserves (Ares)",
		},
	]

    let sidebar = <>
        <Sidebar>
            <SidebarMenu url={location.pathname}/>
        </Sidebar>
    </>;

    const title = "Course Reserves Questions";

    return (
        <SidebarLayout title={title} sidebar={sidebar} breadcrumbs={breadcrumbs}>
            <Seo title={title} keywords={[]} />
            <WebForm name="course-reserves-question">
                <p>The Ares Course Reserve system allows instructors to make course materials available to enrolled students.</p>
                <p>If you're an instructor who wants to book an appointment or place materials on Ares Course Reserve, or if you're a student needing access to Ares Course Reserve materials, please contact us!</p>
                <p>If your question is urgent, we can also be reached during business hours at 519-824-4120 ext 53621.</p>

                {email}

                <label className="required">
                    <span>Please tell us a bit more about how we can help you</span>
                    <textarea name="how_can_we_help_details" rows="5" required />
                </label>
            </WebForm>
        </SidebarLayout>
    )
}

export default CourseReserveQuestion
